module.exports = __webpack_public_path__ + "static/img/pc1.663d37d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc1.png
// module id = Hu2F
// module chunks = 1